import { Paper, Typography } from "@mui/material"
import ProcurementContainer from "../../procurement/containers/ProcurementContainer"
import PaymentScheduleList from "../lists/scheduledPaymentRequisitionsList"
import React from "react";

const PaymentSchedulePage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Payments Schedule
      </Typography>
      
      <Paper sx={{my: 5}}>
        <PaymentScheduleList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default PaymentSchedulePage
